import {inject, injectable} from "inversify";
import type {IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

import type {ISquad} from "data/stores/squads/squds.store";
import type {IRound} from "data/types/entities";
import type {IChecksums} from "data/stores/checksums/checksums.store";
import {LIVE_SCORING_FETCH_TIMING} from "data/constants";

export interface IJSONProvider {
	rounds(): Promise<AxiosResponse<IRound[]>>;
	squads(): Promise<AxiosResponse<ISquad[]>>;
	checksums(): Promise<AxiosResponse<IChecksums>>;
	translations(locale: string): Promise<AxiosResponse<Record<string, unknown>>>;
}

@injectable()
export class JSONProvider implements IJSONProvider {
	constructor(@inject(Bindings.JsonHTTPClient) private _jsonClient: IHttpClientService) {}

	rounds = () => this._jsonClient.get<IRound[]>("rounds.json");

	translations = (locale: string) =>
		this._jsonClient.get<Record<string, unknown>>(`loco/${locale}.json`);

	squads = () => this._jsonClient.get<ISquad[]>("squads.json");
	checksums = () =>
		this._jsonClient.get<IChecksums>(
			"checksums.json",
			{},
			{
				timeout: LIVE_SCORING_FETCH_TIMING - 1000,
			}
		);
}
